module.exports = "/_next/static/images/atelier-background-f72a1484b5f1282a8265c63223c40065.png";